import { createSlice } from "@reduxjs/toolkit";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    villageCount: 0,
    houseHoldCount: 0,
    houseHoldCompleteCount: 0,
    allBeneficiariesCount: [],
    martialStatusCount: [],
    genderStatusCount: [],
    noEducationCount: [],
    familySizeCount: [],
    ageGroupCount: [],
    toiletCardCount: 0,
    waterCardCount: 0,
    hygeineCardCount: 0,
    floodCardCount: 0,
    toiletGraphCount: 0,
    waterSourceGraphCount: 0,
    floodImpactGraphCount: 0,
    handWashGraphCount: 0,
    

  },
  reducers: {
    setvillageCount: (state, action) => {
      state.villageCount = action.payload;
    },
    setHouseHoldCount: (state, action) => {
      state.houseHoldCount = action.payload;
    },
    setHouseHoldCompleteCount: (state, action) => {
      state.houseHoldCompleteCount = action.payload;
    },
    setAllBeneficiariesCount: (state, action) => {
      state.allBeneficiariesCount = action.payload;
    },

    setMartialStatusCount: (state, action) => {
      state.martialStatusCount = action.payload;
    },
    setGenderStatusCount: (state, action) => {
      state.genderStatusCount = action.payload;
    },
    setEducationCount: (state, action) => {
      state.noEducationCount = action.payload;
    },
    setFamilySizeCount: (state, action) => {
      state.familySizeCount = action.payload;
    },
    setAgeGroupCount: (state, action) => {
      state.ageGroupCount = action.payload;
    },

    setToiletCardCount: (state, action) => {
      state.toiletCardCount = action.payload;
    },

    setWaterCardCount: (state, action) => {
      state.waterCardCount = action.payload;
    },
    setHygeineCardCount: (state, action) => {
      state.hygeineCardCount = action.payload;
    },
    setFloodCardCount: (state, action) => {
      state.floodCardCount = action.payload;
    },

    setToiletGraphCount: (state, action) => {
      state.toiletGraphCount = action.payload;
    },
    setWaterGraphCount: (state, action) => {
      state.waterSourceGraphCount = action.payload;
    },
    setFloodImpactGraphCount: (state, action) => {
      state.floodImpactGraphCount = action.payload;
    },
    setHandWashGraphCount: (state, action) => {
      state.handWashGraphCount = action.payload;
    },

  },
});

export const {setWaterCardCount,setHygeineCardCount,setFloodCardCount, setToiletCardCount, setHandWashGraphCount ,setvillageCount, setHouseHoldCount, setHouseHoldCompleteCount , setAllBeneficiariesCount, setMartialStatusCount, setGenderStatusCount,setEducationCount, setFamilySizeCount, setAgeGroupCount, setToiletGraphCount, waterSourceGraphCount, setWaterGraphCount, setFloodImpactGraphCount} = dashboardSlice.actions;
export default dashboardSlice.reducer;